import { Clock3, GitBranch, Layers3 } from 'lucide-react'
import type { buildDocumentResultPresentation } from '../../lib/document-result-presentation'
import { formatRelativeSyncTime } from '../../lib/document-kind'
import { cn } from '../../lib/utils'

type DocumentResultPresentation = ReturnType<typeof buildDocumentResultPresentation>

function ResultTerm({
  dimension,
  term,
  warning = false,
}: {
  dimension: string
  term: { key: string; label: string; description: string }
  warning?: boolean
}) {
  return (
    <span
      className={cn('aw-document-result-term', warning && 'warning')}
      data-dimension={dimension}
      title={term.description}
    >
      {term.label}
    </span>
  )
}

export function DocumentResultTerms({
  presentation,
}: {
  presentation: DocumentResultPresentation
}) {
  const showSync =
    presentation.syncHealth.key !== 'not-applicable' && presentation.syncHealth.key !== 'unknown'
  const showAuthority = presentation.authority.key !== 'unknown'

  return (
    <span className="aw-document-result-terms">
      <ResultTerm dimension="ownership" term={presentation.ownership} />
      <ResultTerm dimension="access" term={presentation.access} />
      {showSync && (
        <ResultTerm
          dimension="sync"
          term={presentation.syncHealth}
          warning={
            presentation.syncHealth.key === 'stale' || presentation.syncHealth.key === 'conflict'
          }
        />
      )}
      {showAuthority && <ResultTerm dimension="authority" term={presentation.authority} />}
    </span>
  )
}

export function DocumentResultDetails({
  presentation,
  updatedAt,
}: {
  presentation: DocumentResultPresentation
  updatedAt: Date | string | number
}) {
  return (
    <span className="aw-knowledge-row-meta">
      <span>
        <GitBranch className="h-3.5 w-3.5" aria-hidden />
        {presentation.source.label}
      </span>
      <span>
        <Layers3 className="h-3.5 w-3.5" aria-hidden />
        {presentation.memoryClassLabel ?? 'No memory class'}
      </span>
      <span>
        <Clock3 className="h-3.5 w-3.5" aria-hidden />
        Updated {formatRelativeSyncTime(updatedAt)}
      </span>
    </span>
  )
}
